export default __webpack_public_path__ + "static/media/italian .37ce3aef.png";